import type { FaireProductEntity } from "../../entity_types/product";

export const p_95r9me6fse: FaireProductEntity = {
  token: "p_95r9me6fse",
  type: "product",
  name: "Tropical Leaf Print Canvas Tote Bag - Large Capacity Shoulder Bag",
  brandToken: "b_8p6hzrhexg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5a489c638aa32b5ebd2d816d73655068d6c181e0573a2e02620f62e0274f24d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/516680aee7118f1dc85f015c83848ef24e70c7503883b9fdcfb26f84781ea3a0.jpeg",
    "https://cdn.faire.com/fastly/6efa5d5d5058c6c0a0857077e18c2095bc3eb24cd21e2146395162693adf5072.jpeg",
    "https://cdn.faire.com/fastly/5cdbfc970ab82e853640bade8074cf81e4402036a8a7b6796d0e7591e83dbdf0.jpeg",
    "https://cdn.faire.com/fastly/62677c27d3ca8ad7fe8b68c1e31aa02946444856594d428943e70f48c57a358f.jpeg",
    "https://cdn.faire.com/fastly/c4f416fc76ebca9ea7b904d13ce68404377abe758d3c53f7cdd7de665e3befea.jpeg",
    "https://cdn.faire.com/fastly/56e4bf1912e2b6fa84f046a40d42cbdf587752d2163c588c47fe2c81f5fb5f03.jpeg",
    "https://cdn.faire.com/fastly/9c2b8dade8dcd95b32da4e22023fb62a1c4651de3b60d614b7e47e979c0d8f45.jpeg",
    "https://cdn.faire.com/fastly/db40737ddc61843f25547c872a38a30c0bbc9a13742bda596c7795de8711a98c.jpeg",
    "https://cdn.faire.com/fastly/90bd874069323b9f38c9b27da8f18e7bd214940d3d805aa9dd6b16d848c6c6be.jpeg",
    "https://cdn.faire.com/fastly/683cbdb6a45a28e828ef0f3ee534078f9ecd485899d6114ee91dcf2fcb3f8bcd.jpeg",
    "https://cdn.faire.com/fastly/49814f7c562c84ccc4dff71b1bf6551fefcfe788621049d8eb5dec5d6a39dc01.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Bring the beauty of the tropics to your daily routine with our Women's Tropical Leaf Print Canvas Tote Bag. This bag showcases a stunning array of colorful, intricate leaf patterns set against a dark background, creating a bold and eye - catching design that¡¯s perfect for summer adventures or adding a touch of the exotic to your everyday style.\n\nMaterial:\n\n * 100% Canvas\n",
  tags: [],
  msrpDollars: 19.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:01.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
